import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "./firebaseConfig";

// Initialize reCAPTCHA verifier
export const setupRecaptcha = (elementId) => {
  window.recaptchaVerifier = new RecaptchaVerifier(auth, elementId, {
    'size': 'invisible',
    'callback': (response) => {
      // reCAPTCHA solved, allow signInWithPhoneNumber.
      console.log("reCAPTCHA solved");
    }
  });
};

// Send OTP to phone number
export const sendOTP = async (phoneNumber) => {
  try {
    // Format phone number with country code (+91 for India)
    const formattedPhoneNumber = `+91${phoneNumber}`;
    
    const appVerifier = window.recaptchaVerifier;
    const confirmationResult = await signInWithPhoneNumber(auth, formattedPhoneNumber, appVerifier);
    
    // Store confirmation result for OTP verification
    window.confirmationResult = confirmationResult;
    
    return {
      success: true,
      message: "OTP sent successfully",
      confirmationResult
    };
  } catch (error) {
    console.error("Error sending OTP:", error);
    
    // Reset reCAPTCHA on error
    if (window.recaptchaVerifier) {
      window.recaptchaVerifier.clear();
    }
    
    return {
      success: false,
      message: getErrorMessage(error.code),
      error: error.code
    };
  }
};

// Verify OTP
export const verifyOTP = async (otp) => {
  try {
    if (!window.confirmationResult) {
      throw new Error("No confirmation result found. Please request OTP again.");
    }
    
    const result = await window.confirmationResult.confirm(otp);
    const user = result.user;
    
    // Get the ID token for backend verification
    const idToken = await user.getIdToken();
    
    return {
      success: true,
      message: "OTP verified successfully",
      user,
      idToken
    };
  } catch (error) {
    console.error("Error verifying OTP:", error);
    
    return {
      success: false,
      message: getErrorMessage(error.code),
      error: error.code
    };
  }
};

// Clean up Firebase auth state
export const cleanupAuth = () => {
  if (window.recaptchaVerifier) {
    window.recaptchaVerifier.clear();
    window.recaptchaVerifier = null;
  }
  if (window.confirmationResult) {
    window.confirmationResult = null;
  }
};

// Get user-friendly error messages
const getErrorMessage = (errorCode) => {
  switch (errorCode) {
    case 'auth/invalid-phone-number':
      return 'Invalid phone number. Please check and try again.';
    case 'auth/too-many-requests':
      return 'Too many requests. Please try again later.';
    case 'auth/invalid-verification-code':
      return 'Invalid OTP. Please check and try again.';
    case 'auth/code-expired':
      return 'OTP has expired. Please request a new one.';
    case 'auth/captcha-check-failed':
      return 'Captcha verification failed. Please try again.';
    default:
      return 'An error occurred. Please try again.';
  }
};
